const widebuttonStyle = {
  "backgroundColor": "#fff",
  "color": "#0072C6",
  "border": "1px solid #0072C6",
  "display": "flex",
  "justifyContent": "center",
  "alignItems": "center",
  "gap": "10px"
}

export const properties = {
    "textbox" : {
      "Label" : "",
      "TextboxIcon":"",
      "Mapping" : "",
      "CustomId":"",
      "Placeholder" : "",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
      "ToggleBtn4":{"field":"Mandatory","label":"Mandatory"},
    },
    "captcha" : {
      "Label" : "",
      "Placeholder" : "",
      "SetRetryCount1": "",
    },
    "textarea" : {
      "Label" : "",
      "Mapping" : "",
      "CustomId":"",
      "Placeholder" : "",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
      "ToggleBtn4":{"field":"Mandatory","label":"Mandatory"},
    },
    "combo" : {
      "Label" : "",
      "TextboxIcon":"",
      "Mapping" : "",
      "CustomId":"",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
      "ToggleBtn4":{"field":"Mandatory","label":"Mandatory"},
    },
    "listbox" : {
      "Inputradio":{label:[ {name: "As a Dropdown", value: "dropDown"}, {name:"As a checkBox", value: "checkBox" }], id:"basicDisplayType", field: "ComboType",},
      "Label" : "",
      "TextboxIcon":"",
      "Mapping" : "",
      "CustomId":"",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
      "ToggleBtn4":{"field":"Mandatory","label":"Mandatory"},
    },
    "checkbox" : {
      "Label" : "",
      "Mapping" : "",
      "CustomId":"",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
      "ToggleBtn4":{"field":"Mandatory","label":"Mandatory"},
    },
    "radio" : {
      "Label" : "",
      "Mapping" : "",
      "CustomId":"",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
      "ToggleBtn4":{"field":"Mandatory","label":"Mandatory"},
    },
    "picklist" : {
      "Label" : "",
      "TextboxIcon":"",
      "Mapping" : "",
      "CustomId":"",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
      "ToggleBtn4":{"field":"Mandatory","label":"Mandatory"},
    },
    "toggle" : {
      "Label" : "",
      "Mapping" : "",
      "CustomId":"",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
      "ToggleBtn4":{"field":"Mandatory","label":"Mandatory"},
    },
    "label" : {
      "Label" : "",
      "Mapping" : "",
      "CustomId":"",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "TextAlignment":""
    },
    "paragraph": {
      "CustomId":"",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
    },
    "link" : {
      "Label" : "",
      "CustomId":"",
      "Mapping" : "",
      "LinkAlignment":"",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
    },
    "iframe" : {
      "Label" : "",
      "CustomId":"",
      "SourceURL": "",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
    },
    "slider" : {
      "Label" : "",
      "Mapping" : "",
      "CustomId":"",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
      "ToggleBtn4":{"field":"Mandatory","label":"Mandatory"},
    },
    "richtext" : {
      "Label" : "",
      "Mapping" : "",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
      "ToggleBtn4":{"field":"Mandatory","label":"Mandatory"},
    },
    "image" : {
      "Label" : "",
      'TextboxIcon' : {'type':'imageUpload',"label":"Upload Image"},
      "CustomId":"",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
    },
    "button" : {
      'Label': "",
      "TextboxIcon":"",
      "CustomId":"",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
    },
    "frame" : {

      "Layout": { field: "SectionType" },
      "Label" : "",
      "TextboxIcon":"",
      "CustomId":"",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
      "ToggleBtn4":{label: "Remove Header", field: "RemoveHeader" },
      
    },
    "section" : {
      "Layout": { field: "SectionType" },
      "Label" : "",
      "TextboxIcon":"",
      "CustomId" : "",
      "longinput3": { label: "User defined ID ", field: "Mapping" },
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
      "ToggleBtn4":{label: "Remove Header", field: "RemoveHeader" },
    },
    "tab" : {
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
      "ToggleBtn4":{"field":"ReadOnly","label":"ReadOnly"},
    },
    "Menu" : {
      "longinput3": { label: "User defined ID ", field: "Mapping" },
    },
    "table" : {
      "Mapping" : "",
      "AddColumnButton" : "",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
    },
    "sidenavigation" : {
      "ToggleShort1":{"label":"Substeps","field":"showSubsteps"},
      "ToggleShort2":{"label":"Add Icons","field":"showIcons"},
      "StepsSubsteps":{},
      "widebutton":{"label":"Add Step","style": widebuttonStyle},
    },
    "wizard_h" : {
      "ToggleShort1":{"label":"Substeps","field":"showSubsteps"},
      "ToggleShort2":{"label":"Add Icons","field":"showIcons"},
      "StepsSubsteps":{},
      "widebutton":{"label":"Add Step","style": widebuttonStyle},
    },
    "wizard_v" : {
      "ToggleShort1":{"label":"Substeps","field":"showSubsteps"},
      "ToggleShort2":{"label":"Add Icons","field":"showIcons"},
      "StepsSubsteps":{},
      "widebutton":{"label":"Add Step","style": widebuttonStyle},
    },
    "imagecarousel" : {
      "UploadCarousel" : "",
      "CustomId" : "",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"AllowAutoScroll","label":"Allow Auto Scroll"},
    },
    "report" :  {
      "PickList": { label: "Choose Report", field: "reportName" },
      "ToggleBtn1": { label: "Visible", field: "Visible" },
      "shortInput": { field: "height", label: "Height" },
    },
    "form" : {

    },
    "tile" : {
      "NoOfTilesQuick":"",
      "TileContents": "",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Mandatory","label":"Mandatory"},
      "TileSelectionType": "",
    },
    "doclist" : {
      "Label": "",
      "Mapping": "",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"}
    },
    "listview" : {
      "Mapping" : "",
      "AddColumnButton" : "",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"}
    },
    "advancelistView" : {
      "Mapping" : "",
      "AddColumnButton" : "",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"}
    },
    "advancelistview" : {
      "AddColumnButton" : "",
      "ToggleBtn2":{"field":"Visible","label":"Visible"},
      "ToggleBtn3":{"field":"Enable","label":"Enable"},
      "CustomId":"",
    },
    "datepick" : {
      "Label": "",
      "Mapping" : "",
      'ControlStyle': {'type':'icon', 'label':'DatePicker Style', 'children':[]},
      "ToggleBtn2": { field: "Visible", label: "Visible" },
      "ToggleBtn3": { field: "Enable", label: "Enable" },
      "ToggleBtn4": { field: "Mandatory", label: "Mandatory" },
    }


  } 

  export const elemTypeJsonMap = {
    frame: 'SECTION',
    section: 'SECTION',
    headerframe: 'SECTION',
    textbox: 'TEXTBOX',
    radio: 'RADIOBOX',
    combo: 'DROPDOWN',
    checkbox: 'CHECKBOX',
    datepick: 'DATEPICKER',
    email: 'EMAIL',
    form: 'PAGE',
    captcha: 'CAPTCHA',
    phonenumber: 'PHONENUMBER',
    button: 'BUTTON',
    textarea: 'TEXTAREA',
    password: 'PASSWORD',
    listbox: 'MULTISELECT',
    toggle: 'TOGGLE',
    tab: 'TAB',
    multiSelect: 'MULTISELECT',
    table: 'TABLE',
    listview: 'LISTVIEW',
    advancelistView: 'ADVANCEDLISTVIEW',
    advancelistview: 'ADVANCEDLISTVIEW',
    label: 'LABEL',
    link: 'LINK',
    paragraph: 'PARAGRAPH',
    iframe: 'IFRAME',
    picklist: 'PICKLIST',
    image: 'IMAGE',
    doclist: 'DocList',
    richtexteditor: 'RICHTEXTEDITOR',
    slider: 'SLIDER',
    imagecarousel: 'IMAGECAROUSEL',
    tile: 'TILE',
    wizard_h: 'Wizard_H',
    wizard_v: 'Wizard_V',
    sidenavigation: 'SideNavigation',
    report: 'Report',
    Menu: 'MENU'
  };